import LeaveControl from './LeaveControl';

export default LeaveControl;
